import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { BodyWrapper, Header, MainWrapper } from '@components';
import { groupMutation } from '@queries';
import { ChevronRightIcon } from '@svgs';

import AccountSidebar from '../components/AccountSidebar/AccountSidebar.jsx';
import GroupForm from '../components/GroupForm/GroupForm.jsx';

export const AddGroup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const mutation = useMutation(
    groupMutation(null, {
      onSuccess: () => {
        // refresh list and return to groups screen
        queryClient.invalidateQueries({ queryKey: ['groups', 'list'] });
        navigate('/dashboard/groups');
      },
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <AccountSidebar />
        <MainWrapper>
          <div className="sb-main-breadcrumbs">
            <ul className="sb-flex">
              <li className="sb-flex">
                <span>Account settings</span>
                <ChevronRightIcon />
              </li>
              <li className="sb-flex">
                <Link to={`/dashboard/groups`}>{t('Groups')}</Link>
                <ChevronRightIcon />
              </li>
              <li className="sb-flex">
                <span>{t('Add')}</span>
              </li>
            </ul>
          </div>
          <div className="sb-manage-content">
            <h1>{t('Add group')}</h1>
            <GroupForm
              mutation={mutation}
              onCancel={() => navigate('/dashboard/groups')}
            />
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
